import React from "react";
import { Card } from "@mui/material";
import { useMode } from "../../mode/ModeContext";
import { modes } from "../../mode/modes";

export default function ModeInsightsCard({
  children,
}: {
  children: React.ReactNode;
}) {
  const { mode } = useMode();
  const color1 = mode ? modes[mode].color1 || "#1976d2" : "#1976d2";
  const color2 = mode ? modes[mode].color2 || "#90caf9" : "#90caf9";
  return (
    <Card
      sx={{
        p: 2,
        mx: 2,
        border: "3px solid transparent",
        borderRadius: 2,
        backgroundImage: `linear-gradient(white, white), linear-gradient(135deg, ${color1} 0%, ${color2} 100%)`,
        backgroundOrigin: "border-box",
        backgroundClip: "padding-box, border-box",
        boxShadow: `0 4px 10px ${color1}40`,
        position: "relative",
      }}
    >
      {children}
    </Card>
  );
}
